import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { refreshUser } from './redux-components/actions/userActions'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

import Footer from './components/Layout/Footer'
import Header from './components/Layout/Header'

import Login from './pages/User-Management/Login'
import Register from './pages/User-Management/Register'

import Dev from './pages/Admin/Dev'
import GroceryV2 from './pages/Widgets/GroceryV2'

import Admin from './pages/Admin/Admin'
import Dashboard from './pages/Dashboard'
import Notes from './pages/Widgets/Notes'
import Shorts from './pages/Widgets/Shorts'
import Reminders from './pages/Widgets/Reminders'
import Error from "./pages/Error/Error";
import ResetPassword from "./pages/User-Management/ResetPassword";
import ForgotPassword from "./pages/User-Management/ForgotPassword";
import Checklist from "./pages/Admin/Checklist";
import Updates from "./pages/Updates";
import Help from "./pages/Help";
import BackgroundImage from "./components/Layout/BackgroundImage";
import RequireFeature from "./components/RequireFeature";
import Settings from "./pages/User-Management/Settings";
import Console from "./pages/Console/Console";

library.add(fab, fas, far);

const App = () => {
  const dispatch = useDispatch();

  // Pick up role and admin changes made since this session logged in
  useEffect(() => {
    dispatch(refreshUser());
  }, [dispatch]);

  return (
    <BrowserRouter>
      <BackgroundImage>
        <Header/>
          <section className='flex flex-grow p-4'>
              <Routes>
                <Route path={'/dev'} element={<RequireFeature adminOnly><Dev/></RequireFeature>} exact />

                <Route path={'/'} element={<RequireFeature feature={'dashboard'}><Dashboard/></RequireFeature>} exact />
                <Route path={'/updates'} element={<Updates/>} exact />
                <Route path={'/help'} element={<Help/>} exact />
                <Route path={'*'} element={<Error/>} />
                <Route path={'/notes'} element={<RequireFeature feature={'notes'}><Notes/></RequireFeature>} exact />
                <Route path={'/shortcuts'} element={<RequireFeature feature={'shortcuts'}><Shorts/></RequireFeature>} exact />
                <Route path={'/reminders'} element={<RequireFeature feature={'reminders'}><Reminders/></RequireFeature>} exact />

                <Route path={'/register'} element={<Register/>} exact />
                <Route path={'/login'} element={<Login/>} exact />
                <Route path={'/resetpassword'} element={<ResetPassword/>} exact />
                <Route path={'/forgotpassword'} element={<ForgotPassword/>} exact />

                <Route path={'/settings'} element={<Settings/>} exact />
                <Route path={'/dashboard'} element={<RequireFeature feature={'dashboard'}><Dashboard/></RequireFeature>} exact />
                <Route path={'/admin'} element={<RequireFeature adminOnly><Admin/></RequireFeature>} exact />
                <Route path={'/grocery'} element={<RequireFeature feature={'grocery'}><GroceryV2/></RequireFeature>} exact />
                <Route path={'/checklist'} element={<RequireFeature feature={'checklist'}><Checklist/></RequireFeature>} exact />

                <Route path={'/console'} element={<RequireFeature feature={'console'}><Console /></RequireFeature>} exact />
              </Routes>
          </section>
        <Footer/>
      </BackgroundImage>
    </BrowserRouter>
  )
}

export default App
